<template>
  <div>
    <FormAddUrl
      :project="project"
      :url="data.url"
      :isResultPage="true"
      :items="url.items"
    />
    <section class="p-seo l-block c-section">
      <div class="p-seo__header">
        <div class="l-block__header">
          <TitleSub level="h2">
            <span class="title">SEOページ評価</span>
          </TitleSub>
        </div>
        <p v-if="data.date" class="c-text--date">
          <span>取得日</span>
          {{ data.date | dateText('YYYY.MM.DD') }}
        </p>
      </div>
      <div class="p-seo l-block__content">
        <LoadingChara v-if="isLoading" variant="inline" class="l-p-0">
          <template slot="title">
            データ取得中
          </template>
        </LoadingChara>
        <Error v-else-if="isError" variant="inline">
          <template slot="title">
            データが取得できませんでした。<br />
            ページを再読み込みしてください。
          </template>
          <Button variant="border" size="w80" fsize="f11" @click="reload">
            <Icon variant="return_gn" :size="12" />
            リロード
          </Button>
        </Error>
        <div v-else class="flex">
          <div class="p-seo__content">
            <DetailSeoEvaluation
              :data="data.seoEvaluation"
              :isLoading="isLoading"
            />
          </div>
          <div class="p-seo__content">
            <DetailSpeed :data="data.speed.device" :isLoading="isLoading" />
            <DetailMobileFriendly
              :data="data.mobileFriendly"
              :isLoading="isLoading"
            />
          </div>
        </div>
      </div>
    </section>
    <DetailSeoIssues
      v-if="!isLoading && !isError"
      :issues="data.issues"
      :project="project"
      :url="data.url"
      :isLoading="isLoading"
    />
  </div>
</template>

<script>
import Button from '@/components/Button';
import DetailMobileFriendly from '@/components/seo/DetailMobileFriendly';
import DetailSeoEvaluation from '@/components/seo/DetailSeoEvaluation';
import DetailSeoIssues from '@/components/seo/DetailSeoIssues';
import DetailSpeed from '@/components/seo/DetailSpeed';
import Error from '@/components/Error';
import FormAddUrl from '@/components/seo/FormAddUrl';
import Icon from '@/components/Icon';
import LoadingChara from '@/components/LoadingChara';
import TitleSub from '@/components/TitleSub';
import apiProjects from '@/api/projects';
import utils from '@/utils';
import axios from 'axios';

export default {
  props: ['date', 'id', 'project'],
  components: {
    Button,
    DetailMobileFriendly,
    DetailSeoEvaluation,
    DetailSeoIssues,
    DetailSpeed,
    Error,
    FormAddUrl,
    Icon,
    LoadingChara,
    TitleSub
  },
  data() {
    return {
      data: {
        date: '',
        issues: [],
        mobileFriendly: {},
        seoEvaluation: {},
        speed: {
          device: {}
        },
        url: ''
      },
      url: {
        items: [],
        isLoading: true
      },
      request: {
        cancelToken: null,
        expiresAt: Date.now() + 10 * 60 * 1000, //10分,
        timeoutDelay: 10 * 1000, //10秒
        timeoutId: null
      },
      isLoading: true
    };
  },
  computed: {
    isError() {
      return (
        (!this.data.seoEvaluation &&
          !this.data.speed &&
          !this.data.mobileFriendly &&
          !this.data.issues) ||
        (!Object.keys(this.data.seoEvaluation).length &&
          utils.isEmpty(this.data.speed.device.mobile) &&
          utils.isEmpty(this.data.speed.device.mobile) &&
          utils.isEmpty(this.data.mobileFriendly.score) &&
          !this.data.issues.length)
      );
    }
  },
  created() {
    if (!this.date || !this.id) {
      this.$router.push({
        name: 'seo'
      });
    }
    this.getSeoChecks();
    this.getUrls();
  },
  destroyed() {
    clearTimeout(this.request.timeoutId);
    // 非同期通信をキャンセル
    if (this.request.cancelToken) {
      this.request.cancelToken.cancel();
    }
  },
  methods: {
    getUrls() {
      // 同一日に調査済みかを判定するために一覧を取得する
      let params = {
        limit: 1000,
        offset: 0
      };
      apiProjects.pageCheckups
        .get(params, this.auth.idToken, this.project.id)
        .then(response => {
          this.url.items = response.data.items;
        })
        .finally(() => {
          this.url.isLoading = false;
        });
    },
    getSeoChecks() {
      let params = {
        types: 'all'
      };
      this.request.cancelToken = axios.CancelToken.source();

      return apiProjects.pageCheckups.result
        .get(
          params,
          this.auth.idToken,
          this.project.id,
          this.id,
          this.request.cancelToken.token
        )
        .then(response => {
          this.data = response.data;
          this.isLoading = false;
        })
        .catch(error => {
          // 非同期処理をキャンセルした時もここを通るが、それ以外の時
          if (!axios.isCancel(error)) {
            // ページアクセスから10分以内であれば再取得のタイマー設定
            if (Date.now() < this.request.expiresAt) {
              this.request.timeoutId = setTimeout(
                this.getSeoChecks,
                this.request.timeoutDelay
              );
            } else {
              this.isLoading = false;
            }
          }
        });
    },
    reload() {
      location.reload(true);
    }
  }
};
</script>
